import { render, staticRenderFns } from "./PrinciplesOfLearning.vue?vue&type=template&id=dcee66ae&scoped=true&"
import script from "./PrinciplesOfLearning.vue?vue&type=script&lang=ts&"
export * from "./PrinciplesOfLearning.vue?vue&type=script&lang=ts&"
import style0 from "./PrinciplesOfLearning.vue?vue&type=style&index=0&id=dcee66ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcee66ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dcee66ae', component.options)
    } else {
      api.reload('dcee66ae', component.options)
    }
    module.hot.accept("./PrinciplesOfLearning.vue?vue&type=template&id=dcee66ae&scoped=true&", function () {
      api.rerender('dcee66ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/index/PrinciplesOfLearning.vue"
export default component.exports